<template>
  <v-navigation-drawer v-model="setsActive" right fixed temporary floating class="elevation-5 pb-0" hide-overlay>
    <v-toolbar>
      <v-toolbar-title>主题设置</v-toolbar-title>
      <v-spacer />
      <v-btn small icon text left @click.native.stop="setsActive = !setsActive">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-sheet class="ma-4 v-settings" color="transparent">
      <strong class="mb-4 d-inline-block">主题颜色设置</strong>
      <v-divider />
      <v-layout justify-center row wrap pa-5>
        <v-radio-group v-model="themeColorThis" column>
          <v-layout v-for="item in themeColors" :key="item.name" row mb-4>
            <v-radio :value="item.name" @change="setThemeColor(item)" />
            <v-btn x-small :class="[item.dark ? 'black' : 'white']" />
            <v-btn x-small :color="item.primary" class="ml-2" />
            <v-btn x-small :color="item.secondary" class="ml-2" />
            <v-btn x-small :color="item.accent" class="ml-2" />
          </v-layout>
        </v-radio-group>
      </v-layout>
    </v-sheet>

    <v-sheet class="ma-4 v-settings" color="transparent">
      <strong class="mb-3 d-inline-block">边栏背景设置</strong>
      <v-divider />
      <v-layout row wrap pa-5 ml-2>
        <v-flex v-for="item in naviColors" :key="item.name" lg2 xs2>
          <v-btn icon max-height="22" max-width="22" :class="[item.class, 'elevation-3']" @click="setNaviColors(item)" />
        </v-flex>
      </v-layout>
    </v-sheet>

    <v-sheet class="ma-4 v-settings" color="transparent">
      <strong class="mb-3 d-inline-block">控制面板设置</strong>
      <v-divider />

      <v-row align="center" no-gutters>
        <v-col cols="auto">页面选项卡</v-col>
        <v-spacer />
        <v-col cols="auto">
          <v-switch v-model="tabsActive" thumb-label hide-details inset></v-switch>
        </v-col>
      </v-row>

      <v-row align="center" no-gutters>
        <v-col cols="auto">菜单栏置顶</v-col>
        <v-spacer />
        <v-col cols="auto">
          <v-switch v-model="naviLocate" thumb-label hide-details inset></v-switch>
        </v-col>
      </v-row>

      <v-row align="center" no-gutters>
        <v-col cols="auto">菜单栏展开</v-col>
        <v-spacer />
        <v-col cols="auto">
          <v-switch v-model="naviActive" thumb-label hide-details inset></v-switch>
        </v-col>
      </v-row>

      <v-row align="center" no-gutters>
        <v-col cols="auto">菜单栏背景</v-col>
        <v-spacer />
        <v-col cols="auto">
          <v-switch v-model="backgroundNav" thumb-label hide-details inset></v-switch>
        </v-col>
      </v-row>
    </v-sheet>
  </v-navigation-drawer>
</template>
<script>
import Themes from "@/commons/themes";
export default {
  components: {},
  data() {
    return {
      themeColorThis: this.$store.getters["settings/themeColor"].name,
      backgroundNav: false,
    };
  },
  computed: {
    themeColors() {
      return Themes.theme_colors;
    },
    naviColors() {
      return Themes.navi_colors;
    },
    //菜单栏折叠
    naviActive: {
      get() {
        return this.$store.getters["settings/naviActive"];
      },
      set(value) {
        this.$store.dispatch("settings/naviActive", value);
      },
    },
    //菜单栏置顶
    naviLocate: {
      get() {
        var val = this.$store.getters["settings/naviLocate"];
        return val == "top" ? true : false;
      },
      set(value) {
        var val = value ? "top" : "left";
        this.$store.dispatch("settings/naviLocate", val);
      },
    },
    //主题设置
    setsActive: {
      get() {
        return this.$store.getters["settings/setsActive"];
      },
      set(value) {
        this.$store.dispatch("settings/setsActive", value);
      },
    },
    //选项卡显
    tabsActive: {
      get() {
        return this.$store.getters["settings/tabsActive"];
      },
      set(value) {
        this.$store.dispatch("settings/tabsActive", value);
      },
    },
  },
  methods: {
    setThemeColor(value) {
      this.$store.dispatch("settings/themeColor", value);
      this.$vuetify.theme.dark = value.dark;
      if (value.dark) {
        this.$vuetify.theme.themes.dark.primary = value.primary;
        this.$vuetify.theme.themes.dark.secondary = value.secondary;
        this.$vuetify.theme.themes.dark.accent = value.accent;
      } else {
        this.$vuetify.theme.themes.light.primary = value.primary;
        this.$vuetify.theme.themes.light.secondary = value.secondary;
        this.$vuetify.theme.themes.light.accent = value.accent;
      }
    },
    setNaviColors(value) {
      this.$store.dispatch("settings/naviColors", value);
    },
  },
};
</script>